interface ChickIconProps {
  className?: string;
}

const ChickIcon = ({ className }: ChickIconProps) => (
  <svg
    viewBox="0 0 120 100"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    role="img"
  >
    {/* Body */}
    <ellipse cx="52" cy="60" rx="26" ry="22" fill="#FFD700" />
    {/* Tail feathers */}
    <ellipse
      cx="24"
      cy="48"
      rx="8"
      ry="14"
      fill="#FFC107"
      transform="rotate(30, 24, 48)"
    />
    <ellipse
      cx="20"
      cy="52"
      rx="6"
      ry="12"
      fill="#FFCA28"
      transform="rotate(20, 20, 52)"
    />
    {/* Head */}
    <circle cx="72" cy="36" r="16" fill="#FFD700" />
    {/* Eye */}
    <circle cx="78" cy="32" r="3" fill="#1a1a1a" />
    <circle cx="79.5" cy="31" r="1" fill="#fff" />
    {/* Beak */}
    <polygon points="88,36 100,40 88,44" fill="#FF8C00" />
    {/* Wing */}
    <ellipse
      cx="44"
      cy="54"
      rx="14"
      ry="10"
      fill="#FFC107"
      transform="rotate(-10, 44, 54)"
    />
    {/* Tuft */}
    <path
      d="M72,20 Q68,10 74,6"
      stroke="#FF8C00"
      strokeWidth="2.5"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M76,22 Q78,12 82,8"
      stroke="#FF8C00"
      strokeWidth="2.5"
      fill="none"
      strokeLinecap="round"
    />
    {/* Legs */}
    <line
      x1="44"
      y1="80"
      x2="44"
      y2="90"
      stroke="#FF8C00"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <line
      x1="60"
      y1="80"
      x2="60"
      y2="90"
      stroke="#FF8C00"
      strokeWidth="3"
      strokeLinecap="round"
    />
    {/* Feet */}
    <path
      d="M36,90 L44,90 L50,90"
      stroke="#FF8C00"
      strokeWidth="3"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M40,93 L44,90"
      stroke="#FF8C00"
      strokeWidth="2.5"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M52,90 L60,90 L66,90"
      stroke="#FF8C00"
      strokeWidth="3"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M56,93 L60,90"
      stroke="#FF8C00"
      strokeWidth="2.5"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export default ChickIcon;
